import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toast } from '@single-platform/components';

export const ToastNotification = ({ message }) => {
  const { t } = useTranslation();
  return (
    <Toast
      isVisible
      animate={false}
      isChildren={false}
      variant={'info'}
      header={t('attention')}
      message={message}
    />
  );
};
